import type { ComponentProps, JSX } from 'solid-js'
import { splitProps } from 'solid-js'

import FieldLabel from './FieldLabel'
import TextInput from './TextInput'

type LabeledInputProps = ComponentProps<'input'> & {
   id: string
   label: JSX.Element
   /** Called with the new raw value on every input event. */
   onValueInput: (value: string) => void
}

/**
 * Renders a labeled text-like input; the label is wired to the input by `id`
 * and input events are reported as plain string values.
 *
 * @param props - Standard input props plus `label` and `onValueInput`.
 * @returns The field element.
 */
const LabeledInput = (props: LabeledInputProps) => {
   const [local, rest] = splitProps(props, ['label', 'onValueInput'])
   return (
      <div>
         <FieldLabel for={rest.id}>{local.label}</FieldLabel>
         <TextInput
            {...rest}
            onInput={event => local.onValueInput(event.currentTarget.value)}
         />
      </div>
   )
}

export default LabeledInput
